export default class Accordion {

constructor(options = {}, lenisInstance = null) {
  this.specialClass = options.specialClass || 'is__special';
  this.activeClass = 'is-active';
  this.lenis = lenisInstance ?? (window.lenis || null);

  this.acdTrigger = Array.from(document.querySelectorAll('.js-acd_trigger'));
  if (this.acdTrigger.length > 0) {
    this.acdToggle();
  }

  //stockページで使用
  this.wrapperTrigger();
}

  acdToggle() {
    this.acdTrigger.forEach(el => {
      const parent = el.closest('.js-acd_parent');
      const isSpecial = parent.classList.contains(this.specialClass);
      const target = parent.querySelector('.js-acd_target');
      const classTarget = parent.querySelectorAll('.js-acd_class_target');
      const btnText = el.querySelector('.o-btn p');

      target.style.overflow = 'hidden';
      target.style.maxHeight = '0px';
      // specialのときだけtransitionを設定する
      if (isSpecial) {
        target.style.transition = 'max-height 0.2s ease';
      }


      el.addEventListener('click', () => {
        const isOpen = el.classList.contains(this.activeClass);
        const lenis = this.lenis;

        if (isSpecial && btnText) {
          btnText.classList.add('is-fading');
          setTimeout(() => {
            btnText.textContent = isOpen ? 'MORE' : 'CLOSE';
            btnText.classList.remove('is-fading');
          }, 500);
        }

        if (isSpecial && isOpen && lenis) {
          const returnTarget = document.querySelector('.js-acd_return');
          const header = document.querySelector('.l-header');
          const offset = -header?.offsetHeight || 0;

          // スクロール → 完了後に閉じる処理
          if (returnTarget) {
            lenis.scrollTo(returnTarget, {
              offset,
              duration: 0.5,
              easing: t => 1 - Math.pow(1 - t, 3),
              onComplete: () => {
                this.toggleAccordion(el, target, classTarget, true, lenis);
              }
            });
            return;
          }
        }

        this.toggleAccordion(el, target, classTarget, isOpen, isSpecial ? lenis : null);
      });
    });
  }

  toggleAccordion(el, target, classTarget, isOpen, lenis) {
    el.classList.toggle(this.activeClass, !isOpen);
    classTarget.forEach(ct => ct.classList.toggle(this.activeClass, !isOpen));
    
    //isOpenの状態に応じてtrue/falseを切り替え
    el.setAttribute('aria-expanded', String(!isOpen));
    target.setAttribute('aria-hidden', String(isOpen));

    //アコーディオン開閉中はlenisをストップさせる
    lenis?.stop();

    if (!isOpen) {
      target.style.maxHeight = target.scrollHeight + 'px';
    } else {
      target.style.maxHeight = target.scrollHeight + 'px';
      //transitionを効かせるため1フレーム遅らせている
      requestAnimationFrame(() => {
        target.style.maxHeight = '0px';
      });
    }

    //transition終了後に以下処理
    const onEnd = (e) => {
      if (e.propertyName !== 'max-height') return;
      target.removeEventListener('transitionend', onEnd);
      //max-heightの指定をリリース=ウィンドウサイズを変えても中身の要素が見切れなくなる
      if (!isOpen) {
        target.style.maxHeight = 'none';
      }
      //ストップさせていたlenisを再開

      lenis?.resize();
      lenis?.start();
    };
    target.addEventListener('transitionend', onEnd);
  }

  // アコーディオンの領域拡張
  wrapperTrigger() {
    const wrappers = document.querySelectorAll('.js-acd_trigger--wrapper');
    wrappers.forEach(wrapper => {
      wrapper.addEventListener('click', (e) => {
        // 既存トリガー要素の処理スキップ
        if (e.target.closest('.js-acd_trigger')) return;
        const trigger = wrapper.querySelector('.js-acd_trigger');
        if (trigger) trigger.click();
      });
    });
  }
}
